export default "__VITE_ASSET__64817431__"